import type { MobxDocument } from '../firestore-mobx'
import {
  empty,
  type FirestoreSlideDeckRubricTestResult,
} from '../firestore/SlideDeckRubricTestResult'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { makeObservable } from 'mobx'

export class SlideDeckRubricTestResult extends ObservableModelWithDecorators<FirestoreSlideDeckRubricTestResult> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideDeckRubricTestResult>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
